export default __webpack_public_path__ + "static/media/Savant's Belt of the Eternal Eclipse.d54d689f.jpg";